import { Grid } from '@mui/material';
import axios from 'axios';
import React from 'react';
import { alertRef } from '../../App';
import Modal from '../../Components/Modal/Modal';
import { Button } from '../../Components/StyledComponents';
import { convertCost } from '../../Utils/functions';
import CouponCreate from './CouponCreate';
import CouponInfo from './CouponInfo';
import './CouponList.scss';

const couponVariant = {
    '상품증정' : '#d8ead3',
    '% 할인' : '#ffe6b4',
    '1+1' : '#cce0ff',
    '원 할인' : '#ffddda'
}

const couponTextVariant = {
    '상품증정' : '#3d9822',
    '% 할인' : '#ffaa00',
    '1+1' : '#0064ff',
    '원 할인' : '#f95f53'
}

const CouponList = () => {
    const [ list, setList ] = React.useState([]);//쿠폰 목록
    const [ info, setInfo ] = React.useState({})//쿠폰 상세 정보

    const modalRef = React.useRef(null);//쿠폰 상세 정보 모달
    const createModalRef = React.useRef(null);//쿠폰 생성 모달

    React.useEffect(() => {
        getCoupons()
    },[])

    //쿠폰 목록 get
    const getCoupons = () => {
        axios.get('/api/coupon')
        .then((data) => {
            setList(data.data)
        })
    }

    //쿠폰 생성
    const createCoupon = (name,description,type,expiryPeriod) => {
        axios.post('/api/coupon', {
            Name :   name,
            Description : description,
            Type : type,
            ExpiryPeriod : Number(expiryPeriod)
        })
        .then((data) => {
            if(data.status === 204){
                createModalRef.current.closeModal();
                getCoupons()
                alertRef.current.showAlert({ title : `쿠폰이 발행되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //쿠폰 삭제
    const deleteCoupon = (id) => {
        axios.delete('/api/coupon/' + id)
        .then((data) => {
            getCoupons();
            modalRef.current.closeModal();
            alertRef.current.showAlert({ title : `쿠폰이 삭제되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
        .catch(() => {
            modalRef.current.closeModal();
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //쿠폰 삭제 확인
    const deleteCouponAlert = (e,data) => {
        if(e.target.id === 'delete-icon'){
            alertRef.current.showAlert({ title : `정말 쿠폰을 삭제하시겠어요?`, isConfirm : true, confirmText : '삭제', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();deleteCoupon(data._id.$oid)} })
        }
    }

    //쿠폰 상세 보기
    const showCouponInfo = (e,data) => {
        if( e.target.id !== 'delete-icon'){
            setInfo(data);
            modalRef.current.openModal();
        }
    }

    return(
        <div className='coupon-list'>
            <p className='header-text'>쿠폰 관리</p>
            <p className='sub-header-text'>발행된 쿠폰 ({list.length})</p>

            {
                list.length > 0 ?
                <Grid container direction={'row'}  alignItems="center" columns={16}>
                    {
                        list.map((data,i) => (
                            <Grid item xs={8} key={i}>
                                <div className='coupon-box' id="coupon-info" onClick={(e) => showCouponInfo(e,data)}>
                                    <div className='row between' id="coupon-info">
                                        <div className='type-box' style={{ backgroundColor : couponVariant[data.Type], color : couponTextVariant[data.Type]}}>
                                            {data.Type}
                                        </div>
                                        {
                                            //발행수가 0인 쿠폰만 삭제가능
                                            data.IssuedCount === 0  &&
                                            <div id='delete-icon' onClick={(e) => deleteCouponAlert(e,data)} style={{ cursor : 'pointer' }}>
                                                <img id='delete-icon' src={require('../../aseets/icons/coupon-delete.svg').default} style={{ width : 24, height : 24, marginRight : 24 }}/>
                                            </div>
                                        }
                                    </div>
                                    <p className='coupon-title'>{data.Name}</p>
                                    <div className='row'>
                                        <p className='info-text'>유효기간 : {data.ExpiryPeriod}일</p>
                                        <p className='info-text'>발행수 : {convertCost(data.IssuedCount)}</p>
                                        <p className='info-text'>사용수 : {convertCost(data.UsedCount)}</p>
                                        <p className='info-text' style={{marginRight : 0}}>반응률 : {(data.UsedCount/data.IssuedCount * 100).toFixed(2) === 'NaN' ? '0.00'  : (data.UsedCount/data.IssuedCount * 100).toFixed(2) }%</p>
                                    </div>
                                </div>
                            </Grid>
                        ))
                        
                    }
                </Grid>
                :
                <div>
                    <p className='empty-list'>생성된 쿠폰이 없습니다.</p>
                </div>
            }

            <Button
                variant="main"
                style={{ width : 163, paddingBottom : 20, paddingTop : 20, alignSelf : 'center', marginTop : 40 }}
                onClick={() => createModalRef.current.openModal()}
            >
                새 쿠폰 발행하기
            </Button>

            <Modal ref={modalRef} contentContainer={{ width : 500 }}>
                <CouponInfo info={info} deleteCoupon={deleteCoupon} closeModal={() => modalRef.current.closeModal()}/>
            </Modal>

            <Modal ref={createModalRef} contentContainer={{ width : 500 }} isHeader title="쿠폰 발행">
                <CouponCreate createCoupon={createCoupon}/>
            </Modal>
        </div>
    )
}

export default CouponList;